
import { motion } from 'framer-motion';

const PolicyHero = () => {
  return (
    <section className="relative py-20 bg-gradient-to-br from-primary to-primary-dark overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute inset-0" style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='1'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
        }}></div>
      </div>

      <div className="max-w-[1440px] mx-auto px-8 relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="text-center"
        >
          <div className="inline-flex items-center gap-2 mb-6">
            <div className="w-3 h-3 bg-accent rotate-45"></div>
            <span className="text-accent text-sm font-semibold uppercase tracking-wider whitespace-nowrap">政策解读</span>
          </div>
          
          <h1 className="text-4xl font-bold text-white mb-4">
            市场采购贸易1039：您的决策参考
          </h1>
          
          <p className="text-lg text-white/80 max-w-2xl mx-auto leading-relaxed mb-8">
            不是政策全文，而是帮您快速判断：是否合法、是否适合、是否值得尝试
          </p>

          <div className="flex justify-center gap-4">
            <button 
              onClick={() => document.getElementById('policy-authority')?.scrollIntoView({ behavior: 'smooth' })}
              className="bg-accent text-primary font-semibold px-6 py-3 rounded-lg hover:bg-accent/90 transition-colors whitespace-nowrap cursor-pointer"
            >
              了解政策依据
            </button>
            <button 
              onClick={() => window.REACT_APP_NAVIGATE?.('/test')}
              className="border-2 border-white text-white font-semibold px-6 py-3 rounded-lg hover:bg-white hover:text-primary transition-all whitespace-nowrap cursor-pointer"
            >
              直接开始测试
            </button>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default PolicyHero;
